import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'welcome_modal_shown';

function WelcomeModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem(STORAGE_KEY);
    if (!alreadyShown) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Overlay - Fondo oscuro */}
      <div
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)',
          backdropFilter: 'blur(4px)', // Le da un toque moderno
          zIndex: 1040,
        }}
        onClick={handleClose}
      />

      {/* Modal Container */}
      <div
        style={{
          position: 'fixed',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          width: '90%',
          maxWidth: '420px',
        }}
      >
        <div className="card shadow-lg border-0" style={{ borderRadius: '20px', overflow: 'hidden' }}>
          <div className="card-body p-4">
            
            {/* Header con Logo */}
            <div className="text-center mb-4">
              <img 
                src="/images/logo.png" 
                alt="Mercado Jopoi" 
                style={{ height: '70px', marginBottom: '15px' }} 
              />
              <h4 className="fw-bold mb-1">¡Bienvenido!</h4>
              <span className="badge rounded-pill bg-warning text-dark px-3">
                Versión Alpha 🚀
              </span>
            </div>

            {/* Aviso de Errores */}
            <div className="alert alert-light border-0 text-center mb-4" style={{ backgroundColor: '#fdf7e3' }}>
              <p className="text-muted small mb-0">
                Esta plataforma está en etapa de pruebas. Podés encontrar errores o comportamientos inesperados
              </p>
            </div>

            {/* Contacto */}
            <div className="mb-4">
              <p className="small fw-bold text-uppercase text-muted mb-2 text-center" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
                ¿Dudas o sugerencias?
              </p>
              
              <div className="list-group list-group-flush border rounded-3 overflow-hidden">
                <a href="mailto:leckiebrian19@gmail.com" className="list-group-item list-group-item-action small py-2">
                  <span role="img" aria-label="email">📧</span> <strong>Email:</strong> leckiebrian19@gmail.com
                </a>
                <a href="https://wa.me/595983763890" target="_blank" rel="noopener noreferrer" className="list-group-item list-group-item-action small py-2">
                  <span role="img" aria-label="whatsapp">📱</span> <strong>WhatsApp:</strong> 0983763890
                </a>
              </div>
            </div>

            {/* Botón de Acción */}
            <div className="d-grid">
              <button className="btn btn-primary btn-lg shadow-sm" onClick={handleClose} style={{ borderRadius: '12px', fontSize: '1rem' }}>
                ¡Entendido, explorar!
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default WelcomeModal;
